import React from 'react'

import { Modal, Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, arrayOf, shape, string, number,
} from 'prop-types'

import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'

import EmptyMessage from '../../EmptyMessage'

const columnsConfig = {
  orderId: { title: 'Order ID', position: 1 },
  purchased: { title: 'Purchased', position: 2 },
  title: { title: 'Product', position: 3 },
  buyer: { title: 'Buyer', position: 4 },
  amount: { title: 'Price', position: 5 },
  royaltiesAmount: { title: 'Earnings to refund', position: 6 },
  refundDate: { title: 'Refund Date', position: 7 },
  refundReason: { title: 'Refund Reason', position: 8 },
}

const renderMoneyValue = (value) => <p>${value}</p>

function RefundsModal({
  isOpen, onClose, refundsData, isLoading = false,
}) {
  const safeRefundsData = Array.isArray(refundsData) ? refundsData : []

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="medium"
      header="Refunds"
      canClose
      disableClose={false}
      secondaryAction={{
        buttonProps: {
          onClick: onClose,
        },
        content: 'Close',
      }}
    >
      <div className="cgt-mt-20">
        {isLoading ? (
          <div className="spinner-container">
            <Spinner />
          </div>
        ) : (
          <LegacyDataTable
            data={safeRefundsData}
            columnsConfig={columnsConfig}
            EmptyMessage={<EmptyMessage title="No refunds information available!" />}
            renderCustomCell={{
              amount: renderMoneyValue,
              royaltiesAmount: renderMoneyValue,
            }}
          />
        )}
      </div>
    </Modal>
  )
}

RefundsModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  isLoading: bool,
  refundsData: arrayOf(
    shape({
      id: string.isRequired,
      orderId: number.isRequired,
      purchased: string.isRequired,
      title: string.isRequired,
      buyer: string.isRequired,
      amount: number.isRequired,
      royaltiesAmount: number.isRequired,
      refundDate: string.isRequired,
      refundReason: string.isRequired,
    })
  ).isRequired,
}

export default RefundsModal
